import axios from "axios";
import {SERVER_IP, SERVER_IP_VIDEO} from "./constants";
import { v4 as uuidv4 } from 'uuid';

export const fetchDocuments = async (userID, serverIP) => {

    console.log("AUTH PROVIDER IP", serverIP)
    console.log("fetch documents userID", userID)
    try {
        const response = await axios.post(serverIP + '/list_papers', {
            "user_id" : userID,
        });
        console.log("response for fetch documents", response)
        if (response.data.status === 'success') {
            const documentList = [];
            for (let i = 0; i < response.data.documents_sorted.length; i++) {
                documentList.push({
                    "id" : response.data.documents_sorted[i].id,
                    "name" : response.data.documents_sorted[i].name,
                    "url" : response.data.documents_sorted[i].url,
                    "highlights" : [],
                    "messages" : [],
                });
            }
            return {
                "status" : 200,
                "documents" : documentList,
            }
        }
    } catch (error) {
        console.log("/list_papers error", error);
        return null;
    }
}

export const fetchAudiobooks = async (userID, serverIP) => {
    console.log("AUTH PROVIDER IP", serverIP)
    console.log("FETCH AUDIOBOOKS userID", userID)
    try {
        const response = await axios.post(serverIP + '/audiobooks/list_audiobooks', {
            "user_id" : userID,
        });
        console.log("response for fetch audiobooks", response)
        if (response.data.status === 200) {
            const documentList = [];
            for (let i = 0; i < response.data.message.length; i++) {
                documentList.push({
                    "id" : response.data.message[i].file_id,
                    "name": uuidv4(),
                    "url" : response.data.message[i].url_for_pdf,
                    "highlights" : [],
                    "messages" : [],
                    "outline" : response.data.message[i].outline,
                    "pageAudioURLs": [],
                });
            }
            return {
                "status" : 200,
                "audiobooks" : documentList,
            }
        }
    } catch (error) {
        console.log("/list_audiobooks error", error);
        return null;
    }
}

export const fetchVideos = async (userID, serverIP) => {
    console.log("fetch videos userID", userID)
    try {
        const response = await axios.post(serverIP + '/videos/list_videos', {
            "user_id" : userID,
        });
        console.log("response for fetch videos", response)
        if (response.data.status === 'success') {
            const documentList = [];
            for (let i = 0; i < response.data.videos_sorted.length; i++) {
                documentList.push({
                    "id" : response.data.videos_sorted[i].id,
                    "name" : response.data.videos_sorted[i].name,
                    "url" : response.data.videos_sorted[i].yt_link,
                    "thumbnail_url" : response.data.videos_sorted[i].thumbnail_url,
                    "highlights" : [],
                    "messages" : [],
                });
            }
            return {
                "status" : 200,
                "videos" : documentList,
            }
        }
    } catch (error) {
        console.log("/list_videos error", error);
        return null;
    }
}

export const fetchGenerations = async (userID, serverIP) => {
    console.log("fetch generations userID", userID)
    try {
        const response = await axios.post(serverIP + '/pdf/list_generations', {
            "user_id" : userID,
        });
        console.log("response for fetch generations", response)
        if (response.data.status === 200) {
            const documentListGeneration = [];
            for (let i = 0; i < response.data.message.length; i++) {
                documentListGeneration.push({
                    "id" : response.data.message[i].generation_id,
                    "name" : response.data.message[i].generation_title,
                    "lastOpenTime" : response.data.message[i].last_open_time,
                    "messages" : [],
                    "files" : [],
                });
            }
            return {
                "status" : 200,
                "generations" : documentListGeneration,
            }
        }
    } catch (error) {
        console.log("/list_generations error", error);
        return null;
    }
}

export const checkProPlan = async (userID, serverIP) => {
    console.log("/subscription/is-premium-user userID", userID)
    try {
        const response = await axios.post(serverIP + '/subscription/is-premium-user', {
            "user_id" : userID,
        });
        console.log("response for /subscription/is-premium-user", response)
        if (response.data.status === 200) {
            if (response.data.message.is_premium_by_domain_allowlist !== undefined) {
                console.log("is_premium_by_domain_allowlist")
                return {
                    "status" : 200,
                    "isProPlanByDomain" : true,
                    "isProPlan": true,
                }
            } else {
                console.log("is_premium")
                return {
                    "status" : 200,
                    "isProPlanByDomain" : false,
                    "isProPlan" : response.data.message.is_premium,
                }
            }
        }
    } catch (error) {
        console.log("/subscription/is-premium-user error", error);
        return null;
    }
}

export const manageSubscription = async (userID, serverIP) => {
    console.log("manage_subscription_clicked")
    console.log("/subscription/manage-subscription userID", userID)
    try {
        const response = await axios.post(serverIP + '/subscription/manage-subscription', {
            "user_id" : userID,
            "service": "justifyai.app"
        });
        console.log("response for /subscription/manage-subscription", response)
        if (response.data.status === 200) {
            return {
                "status" : 200,
                "url" : response.data.message.url,
            }
        }
    } catch (error) {
        console.log("/subscription/manage-subscription error", error);
        return null;
    }
}

export const maxOutUsage = async (userID, keysToMax, serverIP) => {
    console.log("maxed_out_usage")
    console.log("/subscription/max-out-user-free-usage userID", userID)
    try {
        const response = await axios.post(serverIP + '/subscription/max-out-user-free-usage', {
            "user_id" : userID,
            "keys_to_max" : keysToMax,
        });
        console.log("response for /subscription/max-out-user-free-usage", response)
        if (response.data.status === 200) {
            return {
                "status" : 200,
            }
        }
    } catch (error) {
        console.log("/subscription/max-out-user-free-usage error", error);
        return null;
    }
}

